module.exports = __webpack_public_path__ + "img/logo_ma_plus_bordeaux.33ee58e3.svg";